<template>
  <div class="host">
    <div class="vm-form-field">
      <slot @has="has" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    has(event) {
      console.log(event);
    }
  }
};
</script>

<style scoped>
.vm-form-field {
  position: relative;
  margin-bottom: 24px;
}
</style>
